import React from 'react';
import PropTypes from 'prop-types';
import NegotiationModal from '../NegotiationModal';
import { TradeContext } from '../../../_shared/types/trade';

const propTypes = {
  trade: PropTypes.oneOfType([PropTypes.object]).isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tradeContext: PropTypes.oneOf([TradeContext.Buy, TradeContext.Sell]),
  isOmp: PropTypes.bool
};

// tradeContext is temporarily missing from NegotiationModalButtonContainer. This should be removed once addressed.
const defaultProps = {
  tradeContext: null,
  isOmp: false
};

const NegotiationModalContainer = ({
  trade,
  modalIsOpen,
  onClose,
  tradeContext,
  isOmp
}) => {
  const tradeDetails = trade;

  if (!modalIsOpen) {
    return null;
  }

  return (
    <NegotiationModal
      key={`negotiationModal-${tradeDetails.id}-${tradeDetails.auctionId}`}
      modalIsOpen={modalIsOpen}
      onClose={onClose}
      tradeDetails={tradeDetails}
      tradeContext={tradeContext}
      isOmp={isOmp}
    />
  );
};

NegotiationModalContainer.propTypes = propTypes;
NegotiationModalContainer.defaultProps = defaultProps;

export default NegotiationModalContainer;
